export default function Impressum() {
  return (
    <div data-testid="impressum-page" className="pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="text-xs uppercase tracking-[0.3em] text-stone-500 mb-6">Rechtliches</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-light tracking-tight mb-12">Impressum</h1>

        <div className="prose prose-stone max-w-none text-stone-700 space-y-8 text-[15px] leading-relaxed">
          <section>
            <h2 className="font-heading text-xl font-medium text-[#1C1C1C] mb-3">Angaben gemäß § 5 TMG</h2>
            <p>
              Linea Bodendesign<br />
              Weserstr. 133<br />
              32457 Porta Westfalica<br />
              Deutschland
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-[#1C1C1C] mb-3">Kontakt</h2>
            <p>
              Telefon: +49 171 158 41 30<br />
              E-Mail: info@linea-boden-design.de
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-[#1C1C1C] mb-3">Vertreten durch</h2>
            <p>[Inhaber / Geschäftsführer]</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-[#1C1C1C] mb-3">Umsatzsteuer-ID</h2>
            <p>USt-IdNr.: [DE000000000]</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-[#1C1C1C] mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>[Name]<br />[Adresse]</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-[#1C1C1C] mb-3">Haftungsausschluss</h2>
            <p>
              Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt.
              Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
              kann jedoch keine Gewähr übernommen werden.
            </p>
          </section>

          <p className="text-xs text-stone-500 pt-6 border-t border-stone-200">
            Dieser Text ist eine Platzhalter-Vorlage. Bitte vor Veröffentlichung
            durch tatsächliche Unternehmensangaben ersetzen.
          </p>
        </div>
      </div>
    </div>
  );
}
